import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class LoadingService {
  public showLoadingSpinner = false;

  constructor() { }
}
